/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.UserChangePasswordResponse,
  userChangePassword: (params: vp.UserChangePasswordRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostUserChangePassword: ApiHook = ({ api }) => {
  const [shouldUserChangePassword, setShouldUserChangePassword] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.UserChangePasswordRequest>({
    EmailAddress: '',
    NewPassword: '',
    SendEmail: false,
  });
  const [response, setResponse] = useState<vp.UserChangePasswordResponse>({
    Success: false,
    ErrorMessage: '',
    Username: '',
    Password: '',
  });

  useEffect(() => {
    if (!shouldUserChangePassword) return () => {};

    const ChangeUserPassword = async () => {
      setDataFetchingInfo(true, 'changing user password', 'fullScreen');
      const res = await api.postUserChangePassword(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldUserChangePassword) void ChangeUserPassword();
    setShouldUserChangePassword(false);
    return () => {
      source.cancel();
    };
  }, [shouldUserChangePassword]);

  return [
    response,
    (_params: vp.UserChangePasswordRequest) => {
      setParams(_params);
      setShouldUserChangePassword(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Username: '',
        Password: '',
      });
      setShouldUserChangePassword(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostUserChangePassword);
